export default "__VITE_ASSET__afee6b43__"